import { render, staticRenderFns } from "./record.vue?vue&type=template&id=7c1e2b09&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e2b09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1e2b09')) {
      api.createRecord('7c1e2b09', component.options)
    } else {
      api.reload('7c1e2b09', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=7c1e2b09&scoped=true", function () {
      api.rerender('7c1e2b09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/btn/record.vue"
export default component.exports